import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import CustomCursor from './components/CustomCursor';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import Home from './pages/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import Quote from './pages/Quote';
import Corporate from './pages/services/Corporate';
import Wedding from './pages/services/Wedding';
import Launch from './pages/services/Launch';
import Private from './pages/services/Private';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CustomCursor />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/services/corporate" element={<Corporate />} />
            <Route path="/services/wedding" element={<Wedding />} />
            <Route path="/services/launch" element={<Launch />} />
            <Route path="/services/private" element={<Private />} />
          </Routes>
        </main>
        <Footer />
        <FloatingWhatsApp />
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
